import _ from "lodash";
import React from "react";
import classes from "./ResponseItemV2.scss";
import ProfileCascade from "UIComponents/ProfileCascade";
import Textview from "UIComponents/Textview";
import classNames from "classnames";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { AttachmentList } from "Attachment";
import { getFormattedEvidence } from "Utils/DataRestructure";
import { useI18n } from "Hooks";

const profileAvatarStyles = {
  shape: "square",
  size: "medium",
  color: "neutral",
  iconType: "none",
  shade: "light",
  randomizeColor: true,
};

const ResponseItemV2 = ({ item, onMediaClick, isSinglePageAndNewUnitView }) => {
  const { message, evidence, createdBy } = item;
  const { id: creatorId, firstName, profileImage } = createdBy;
  const totalAttachments = _.get(evidence, "length", 0);
  const { t } = useI18n();
  const showCount = totalAttachments > 0 && !message;
  return (
    <div className={classes.container}>
      <div className={classes.profileContainer}>
        <ProfileCascade
          items={[{ id: creatorId, value: firstName, imageUrl: profileImage }]}
          avatarStyles={profileAvatarStyles}
          showAvatar={true}
          dsVersion={"2.0"}
        />
      </div>
      <div className={classes.contentContainer}>
        <div
          className={classNames("text-label", {
            [classes.nameText]: true,
          })}
        >
          {getFormattedUserName({ user: createdBy })}
        </div>
        <div className={classes.richText} />
        {message && (
          <Textview
            mode={"view"}
            value={message}
            showViewEmpty={false}
            isWordWrapRequired={true}
            isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
          />
        )}
        {showCount && (
          <div className={classNames("text-body", classes.fileCount)}>
            {`${t("common:attached_file_count", {
              count: totalAttachments,
            })}`}
          </div>
        )}
        {totalAttachments ? (
          <div className={!showCount ? classes.lowerContainer : ""}>
            <AttachmentList
              cardType={"design-media-card"}
              value={getFormattedEvidence({ evidence })}
              showCreateDropdown={false}
              onClickAttachmentCard={onMediaClick}
              mode={"view"}
              showAttachmentAsPost={true}
              isPrintEnabled={false}
              isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ResponseItemV2;
